let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5P99A")).then(() => parcelRequire('l0U1U'));